exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1fprw6OFYmFYjnrfbpgSWd::placeholder{color:#909090}", ""]);

// exports
exports.locals = {
	"input": "_1fprw6OFYmFYjnrfbpgSWd"
};